"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CollapsibleTableRow = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _CopyButton = _interopRequireDefault(require("./CopyButton"));
var _context2, _context3;
var styles = {
  "container": "collapsible_table-module__container___kOXrj",
  "controls": "collapsible_table-module__controls___wD5TA",
  "control": "collapsible_table-module__control___hTnE8",
  "activated": "collapsible_table-module__activated____Zbcb",
  "line_break": "collapsible_table-module__line_break___HL4hp",
  "row": "collapsible_table-module__row___yf0Fx",
  "row_controls": "collapsible_table-module__row_controls____FJyV",
  "row_control": "collapsible_table-module__row_control___LPsSt",
  "row_copy": "collapsible_table-module__row_copy___dKdKa",
  "row_contents": "collapsible_table-module__row_contents___INVXS"
};
const CollapsibleTableRow = {
  headerId: _propTypes.default.string.isRequired,
  children: _propTypes.default.element,
  data: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array, _propTypes.default.string]).isRequired,
  hideCopyBtn: _propTypes.default.bool
};
exports.CollapsibleTableRow = CollapsibleTableRow;
class CollapsibleRow extends _react.default.Component {
  static propTypes = {
    headerId: _propTypes.default.string,
    onClick: _propTypes.default.func,
    data: CollapsibleTableRow.data,
    isExpanded: _propTypes.default.bool,
    hideCopyBtn: _propTypes.default.bool,
    children: _propTypes.default.element,
    rowClassName: _propTypes.default.string,
    rowControlsClassName: _propTypes.default.string,
    rowContentsClassName: _propTypes.default.string
  };
  render() {
    const {
      headerId,
      onClick,
      data,
      isExpanded,
      hideCopyBtn,
      children,
      rowClassName,
      rowControlsClassName,
      rowContentsClassName
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.row, rowClassName)
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.row_controls, rowControlsClassName)
    }, /*#__PURE__*/_react.default.createElement("span", {
      "data-testid": headerId + "-control",
      className: (0, _classnames.default)(styles.row_control, {
        [styles.activated]: isExpanded
      }),
      onClick: onClick
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: headerId
    }), !hideCopyBtn && /*#__PURE__*/_react.default.createElement(_CopyButton.default, {
      className: styles.row_copy,
      data: data
    })), isExpanded && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.row_contents, rowContentsClassName)
    }, children));
  }
}
function getRowsExpanded(rows, shouldExpand = false) {
  return (0, _reduce.default)(rows).call(rows, (expandedAcc, {
    headerId,
    defaultExpanded
  }) => ({
    ...expandedAcc,
    [headerId]: defaultExpanded || shouldExpand
  }), {});
}
class CollapsibleTable extends _react.default.Component {
  static propTypes = {
    contentBefore: _propTypes.default.element,
    containerClassName: _propTypes.default.string,
    controlClassName: _propTypes.default.string,
    message: _propTypes.default.string,
    messageClassName: _propTypes.default.string,
    rows: _propTypes.default.arrayOf(_propTypes.default.shape(CollapsibleTableRow))
  };
  constructor(props) {
    super(props);
    this.state = {
      rowsExpanded: getRowsExpanded(props.rows)
    };
  }
  areRowsExpanded() {
    var _context;
    return (0, _some.default)(_context = (0, _values.default)(this.state.rowsExpanded)).call(_context, rowExpanded => rowExpanded);
  }
  collapseAllRows = (0, _bind.default)(_context2 = this.collapseAllRows).call(_context2, this);
  collapseAllRows() {
    this.setState({
      rowsExpanded: getRowsExpanded(this.props.rows)
    });
  }
  expandAllRows = (0, _bind.default)(_context3 = this.expandAllRows).call(_context3, this);
  expandAllRows() {
    this.setState({
      rowsExpanded: getRowsExpanded(this.props.rows, true)
    });
  }
  onRowClick(headerId) {
    this.setState(prevState => ({
      rowsExpanded: {
        ...prevState.rowsExpanded,
        [headerId]: !prevState.rowsExpanded[headerId]
      }
    }));
  }
  componentDidUpdate(prevProp) {
    if (prevProp.rows.length !== this.props.rows.length) {
      var _context4;
      const {
        rowsExpanded
      } = this.state;
      const updatedRowsExpanded = (0, _reduce.default)(_context4 = this.props.rows).call(_context4, (expandedAcc, {
        headerId,
        defaultExpanded
      }) => {
        const isExpanded = defaultExpanded || rowsExpanded[headerId];
        return {
          ...expandedAcc,
          [headerId]: isExpanded
        };
      }, {});
      this.setState({
        rowsExpanded: updatedRowsExpanded
      });
    }
  }
  renderMessageBar(message, messageClassName) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: styles.row
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: messageClassName
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: message,
      values: {
        b: chunks => /*#__PURE__*/_react.default.createElement("b", null, chunks)
      }
    })));
  }
  render() {
    const {
      contentBefore,
      rows,
      containerClassName,
      controlClassName,
      message,
      messageClassName
    } = this.props;
    const {
      rowsExpanded
    } = this.state;
    const areRowsExpanded = this.areRowsExpanded();
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, containerClassName)
    }, contentBefore, /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.controls, controlClassName)
    }, /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.collapsibleTable.collapseAll",
      className: (0, _classnames.default)(styles.control, {
        [styles.activated]: !areRowsExpanded
      }),
      onClick: this.collapseAllRows
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: styles.line_break
    }), /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      displayId: "au.collapsibleTable.expandAll",
      className: (0, _classnames.default)(styles.control, {
        [styles.activated]: areRowsExpanded
      }),
      onClick: this.expandAllRows
    })), message && this.renderMessageBar(message, messageClassName), (0, _map.default)(rows).call(rows, ({
      headerId,
      data,
      children,
      hideCopyBtn,
      ...restProps
    }) => {
      return /*#__PURE__*/_react.default.createElement(CollapsibleRow, (0, _extends2.default)({
        key: headerId,
        headerId: headerId,
        onClick: () => this.onRowClick(headerId),
        hideCopyBtn: hideCopyBtn,
        data: data,
        isExpanded: rowsExpanded[headerId]
      }, restProps), children);
    }));
  }
}
exports.default = CollapsibleTable;